







































































































































































































































































































































































import {
  Component,
  namespace,
  Prop,
  Vue,
  Watch,
} from "nuxt-property-decorator";
import {IProduct} from "sitisjs/dist/internal/sections/products/models/Product";
import ProductPrice from "~/components/product/ProductPrice.vue";
import WishlistButton from "~/components/product/WishlistButton.vue";
import WishlistButtonStore from "~/components/product/WishlistButtonStore.vue";
import ProductToCartButton from "~/components/product/ProductToCartButton.vue";
import {
  namespace as cartStore,
  actionType as cardActionType,
} from "../../node_modules/sitis-nuxt/lib/store/modules/cart-store";
import CharacteristicsList from "~/components/product/main-product-card/CharacteristicsList.vue";

const CardStore = namespace(cartStore);

@Component({
  name: "MainProductCard",
  components: {
    CharacteristicsList,
    ProductPrice,
    WishlistButton,
    WishlistButtonStore,
    ProductToCartButton,
  },
})
export default class ProductCard extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  private readonly product!: IProduct;

  isShowPopupProduct: boolean = false;
  typePopupProduct: string = "";
  indexPopupProduct: number = 0;

  @Prop({type: Boolean}) private readonly isInWishlist!: boolean;
  @Prop({type: Boolean}) private readonly wishStore!: boolean;
  @Prop({type: Boolean}) private readonly isCardSmall!: boolean;
  @Prop({type: Boolean}) private readonly loadingWishlist!: boolean;
  @Prop({type: Boolean}) private readonly saveCurrentPosition!: boolean;
  @Prop({type: Number}) private readonly imageId!: null;

  private productPage!: number;
  @Prop({type: Number}) page!: number;
  $cookies: any;
  $api: any;
  $customNotification: any;
  $yandexCommerce: any;
  $yandexMetrika: any;

  @Watch("page", {immediate: true})
  onChangePage(): void {
    if (!this.productPage) {
      this.productPage = this.page;
    }
  }

  get shortCharacteristics() {
    let character: object [] = [];
    if (this.product.shortCharacteristics) {
      this.product.shortCharacteristics.map((char: any) => {
        let newString: string [] = [];

        char.values.map((t: any) => {
          newString.push(t.value);
        })

        character.push(
          {
            "name": char.name, "value": newString
          }
        )
      })
    }

    return character;
  }

  get productImageId(): string {
    if (this.imageId) {
      return `${this.imageId}`;
    }

    return `${this.product.imageId}`;
  }

  get productPath(): string {
    return `${this.product.url}`;
  }

  get isProductFittedProducts(): boolean {
    const fitted_products =
      this.$store.state?.myacuvue?.profile?.fitted_products || {};

    return Boolean(fitted_products[this.product.id]);
  }

  get isProductFreeProducts(): boolean {
    return (this.$store.state?.myacuvue?.profile?.free_products || []).includes(
      this.product.id
    );
  }

  get bonusValueTotal() {
    const myAcuvue = this.$store.state?.myacuvue?.profile || {};
    const fittedProducts = myAcuvue?.fitted_products || {};

    if (fittedProducts[this.product?.id]) {
      return fittedProducts[this.product?.id]?.bonuses;
    }

    const product = JSON.parse(JSON.stringify({...this.product}));
    return product?.bonusValue || product?.bonus_value || "";
  }

  get isBonusMyAcuvue() {
    const myAcuvue = this.$store.state?.myacuvue?.profile || {};
    const fittedProducts = myAcuvue?.fitted_products || {};

    if (fittedProducts[this.product?.id]) {
      return true;
    }

    return false;
  }

  get isNotAvailable() {
    return this.product?.isNotAvailable || false;
  }

  // Логика оторбражения / управления колличеством товара в корзине
  get isAddedToCart() {
    const cartItems = this.$store.state?.cart?.items || [];
    const isAdded = Boolean(
      cartItems.find((t: any) => t?.product?.id === this.product?.id)
    );

    return isAdded;
  }

  get countAddedToCart() {
    const cartItems = this.$store.state?.cart?.items || [];
    const product = cartItems.find((t: any) => t?.product?.id === this.product?.id) || {};

    return product?.quantity || 0;
  }

  async changeQuantityProduct(type: String): Promise<void> {
    const cartItems = this.$store.state?.cart?.items || [];
    const product = cartItems.find((t: any) => t?.product?.id === this.product?.id) || {};
    const url = `cart/${product.id}`;
    const newQuantity = Boolean(type === "+") ? product.quantity + 1 : product.quantity - 1;

    if (newQuantity === 0) {
      await this.deleteProductFromCard(url);
      await this.updateCartItems();
      return;
    }

    const response = await this.$api.agent.transport
      .put(url, {
        quantity: newQuantity,
      })
      .then((res: any) => {
        return res.data;
      })
      .catch((err: any) => {
        return {error: err.response};
      });
    if (response.error) {
      const errorData = response.error?.data;

      let errorMessage = '';
      if (Array.isArray(errorData)) {
        errorMessage = (errorData || []).map((t) => t.message).join('; <br/>')
      }
      this.$customNotification.error(
        errorMessage || "Ошибка изменения количества товара в корзине. Попробуйте позже."
      );

      return;
    }

    await this.updateCartItems();
  }

  async deleteProductFromCard(url: String): Promise<void> {
    const response = await this.$api.agent.transport
      .delete(url)
      .then((res: any) => {
        return res.data;
      })
      .catch((err: any) => {
        return {error: err.response};
      });

    if (response.error) {
      this.$customNotification.error(
        "Ошибка удаления товара из корзины. Попробуйте позже."
      );

      return;
    }

    this.$yandexCommerce("remove", [{
      ...this.product,
      quantity: 1
    }]);

    this.updateCartItems();
  }

  // --------------------------

  putToCart(): void {
    this.$emit("put-to-cart", this.product.id);
  }

  addToFavorite(): void {
    this.$emit("add-to-favorite", this.product.id);

  }

  replaceUrlSearch(): void {
    // Функционал замена ссылки только для раздела каталог
    if (this.$route.name === "catalog-all") {
      var queryParams = new URLSearchParams(window.location.search);
      queryParams.set("page", this.productPage.toString());
      history.replaceState(null, "", `?${queryParams}`);
    }

    // Функция записи ID продукта при переходе с каталога (saveCurrentPosition должен быть true)
    if (this.saveCurrentPosition) {
      // this.$cookies.set('scroll-to-product-id', String(this.product.id));
    }

    this.$router.push(this.productPath);
  }

  onTapWishMobile() {
    if (this.isInWishlist) {
      this.$emit("remove-from-wishlist", this.product.id);

      return null;
    }

    this.$emit("add-to-wishlist", this.product.id);
  }

  fastBuyProduct = () => {
    const keyPhrase = 'acuvue';
    if (this.product?.slug?.toLowerCase().includes(keyPhrase)) {
      this.$yandexMetrika.reachGoal('buy_myacuvue_catalog_A');
    }
    this.$store.commit("fast-buy/setProductId", this.product.id);
  };

  readMyAcuvueInfo() {
    this.isShowPopupProduct = true;
    this.typePopupProduct = "my-acuvue";
  }

  readPresent() {
    this.isShowPopupProduct = true;
    this.typePopupProduct = "present";
  }

  readStock(index: number) {
    this.isShowPopupProduct = true;
    this.typePopupProduct = "stock";
    this.indexPopupProduct = index;
  }

  @CardStore.Action(cardActionType.GET_CART)
  readonly updateCartItems!: () => Promise<boolean>;
}
